import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import OwlCarousel from "react-owl-carousel";
import live_session_img1 from "../../../assets/images/dummy/live_session_img1.png";
import dummy_coach1_sqr from "../../../assets/images/dummy/dummy_coach1_sqr.png";
import mental_coach from "../../../assets/images/dummy/mental_coach.png";
import { NavLink } from "react-router-dom";
import BlogModalComponent from "./blog_details";
import { getAllBlogs, allCategories, allAuthor } from "../../../utils/api";
import send_wht from "../../../assets/images/icons/send_wht.png";
import quote_grn from "../../../assets/images/icons/quote_grn.png";
import blog_card_img1 from "../../../assets/images/dummy/blog_card_img1.png";
import testimonials_img1 from "../../../assets/images/dummy/testimonials_img1.png";
// import { allCategories } from './../../../utils/api/index';
import { PulseLoader } from "react-spinners";
import { Helmet } from "react-helmet";
import Button from "./../../../components/Button";
import BlogCard from "../../../components/BlogCard";

function BlogComponent() {
  var count = 0;
  var counter = 0;
  const [allBlogs, setAllBlogs] = useState([]);
  const [latestBlogs, setLatestBlogs] = useState([]);
  const [alltestimonial, setTestimonials] = useState([]);
  const [allSelectedCate, setAllSelectedCate] = useState([]);
  const [featuredBlogs, setFeaturedBlogs] = useState([]);
  const [popularBlogs, setPopularBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectAuthors, setSelectAuthors] = useState([]);
  const [authorList, setAuthorList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [contentloading, setContentLoading] = useState(true);

  function getDate(time) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Octr",
      "Nov",
      "Dec",
    ];

    const date = new Date(time).getDate();
    const year = new Date(time).getFullYear();
    const month = months[new Date(time).getMonth()];

    let hour = new Date(time).getHours();
    let minute = new Date(time).getMinutes();

    const am_pm = hour > 12 ? "PM" : "AM";
    const time_string = `${date} ${month} ${year}`;
    return time_string;
  }

  useEffect(() => {
    const canonicalUrl = window.location.origin + window.location.pathname;
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

    getData();
    window.scrollTo(0, 0);
  }, []);

  const getData = async () => {
    // const data = await getAllBlogs();
    // if (data.data) {
    //     if (data.data.data) {
    //         setAllBlogs(data.data.data.all)
    //         setLatestBlogs(data.data.data.latest)
    //         setFeaturedBlogs(data.data.data.featured)
    //         setPopularBlogs(data.data.data.popular)
    //     }
    //     setTestimonials(data.data.testimonial)
    // }
    let allSelectedCate = "";
    filterCate(allSelectedCate);
    const allcat = await allCategories();
    if (allcat) {
      console.log(allcat.data.data);
      setCategories(allcat.data.data);
    }
    const allAuthors = await allAuthor();
    if (allAuthors) {
      setAuthorList(allAuthors.data.data);
      console.log(allAuthors.data.data, "allAuthor");
    }
    setLoading(false);
  };

  const [blogModalShow, setBlogModalShow] = React.useState(false);
  const [singleBlogDetails, setSingleBlogDetails] = React.useState("");
  console.log("alltestimonial", alltestimonial);
  const showModal = (e, blog) => {
    setBlogModalShow(true);
    setSingleBlogDetails(blog);
  };

  const removeHTMLTags = (str) => {
    return str.replace(/<[^>]+>/g, ""); // Remove HTML tags
  };
  const defaultUserImage = (e) => {
    // e.target.src = 'https://api.vaffix.com/uploads/images/avatar_dummy.webp';
    e.target.src = blog_card_img1;
  };
  const options = {
    items: 1,
    // nav: true,
    // navText: ["<span className='owl_nav_btn prev_slide'>Previous</span>", "<span className='owl_nav_btn next_slide'>Next</span>"],
    rewind: true,
    // autoplay: true,
    dots: true,
    dotsEach: true,
    dotData: true,
  };
  const defaultImage = (e) => {
    e.target.src = blog_card_img1; //'https://admin.qoach.io/assets/images/blog.png';
  };
  const selectCate = (e) => {
    const index = allSelectedCate.indexOf(e.target.value);
    if (index !== -1) {
      allSelectedCate.splice(index, 1);
    } else {
      allSelectedCate.push(e.target.value);
    }
    console.log(allSelectedCate);
    filterCate(allSelectedCate, "category");
    setAllSelectedCate(allSelectedCate);
  };
  const selectAuthor = (e) => {
    const selectedAuthor = e.target.value;

    // First, update the selected author state
    setSelectAuthors(selectedAuthor);

    // Ensure the filter applies correctly with the latest state
    filterCate(selectedAuthor, "author");
  };
  const filterCate = async (list, type) => {
    setContentLoading(true); // Show loader before API call
    const formData = new FormData();
    // let cat = "";
    if (list !== "") {
      if (type === "category") {
        const modifiedStrings = list.map((str) => str.replace("cate", ""));
        const commaSeparatedString = modifiedStrings.join(",");
        formData.append("categories", commaSeparatedString);
      } else {
        const modifiedStrings = allSelectedCate.map((str) =>
          str.replace("cate", "")
        );
        const commaSeparatedString = modifiedStrings.join(",");
        formData.append("categories", commaSeparatedString);
      }
      if (type === "author") {
        formData.append("author", list);
      } else {
        formData.append("author", selectAuthors);
      }
    }
    const data = await getAllBlogs(formData);
    if (data.data) {
      if (data.data.data) {
        setAllBlogs(data.data.data.all);
        setLatestBlogs(data.data.data.latest);
        setFeaturedBlogs(data.data.data.featured);
        setPopularBlogs(data.data.data.popular);
      }
      setTestimonials(data.data.testimonial);
    }
    setContentLoading(false); // Show loader before API call
  };
  const scrollLeft = () => {
    const container = document.getElementById("filterScroll");
    container.scrollLeft -= 100;
  };
  const scrollRight = () => {
    const container = document.getElementById("filterScroll");
    container.scrollLeft += 100;
  };
  return (
    <>
      <Helmet
        htmlAttributes={{ lang: "en" }}
        title="Explore Insights and Wisdom | Qoach Blog Hub"
        meta={[
          {
            name: "description",
            content:
              "Discover a treasure trove of insights and wisdom from our expert coaches. Dive into our blog hub to gain valuable knowledge and inspiration on personal growth, career advancement, wellness, and more. Start your journey of discovery with Qoach today!",
          },
        ]}
      />
      {loading ? (
        // <PulseLoader color="#36D7B7" loading={loading} size={15} />
        <div
          style={{
            // textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100vw",
          }}
        >
          <p>
            <PulseLoader color="#00504E" size={20} />
          </p>
        </div>
      ) : (
        <>
          {/*<section className="py-5 brand_bg_color4">
                      <Container>
                          <Row className="justify-content-center">
                              <Col lg="12">
                                  <div className="text-white hdng_a poppins_fnt">
                                      <h6 className="text-white text-uppercase">NEWS & COMMUNITY</h6>
                                      <h2 className="text-white">Our Latest Blogs</h2>
                                      <p className="m-0 fs-16 fw-400 text_white_color_half">Get Inspired: Explore What Our Coaches Have to Say in Their Latest Blogs</p>
                                  </div>
                              </Col>
                          </Row>
                      </Container>
                    </section>
                    <section className="my-5 blog-filter">
                        <Container>
                            <Row>
                                <div className="col-12">
                                    <div className="d-flex align-items-start justify-content-between filter-buttons">
                                        <button onClick={scrollLeft} className="bg-transparent prev-btn ps-2 pe-4">
                                            <svg width="20px" height="20px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.1795 3.26875C15.7889 2.87823 15.1558 2.87823 14.7652 3.26875L8.12078 9.91322C6.94952 11.0845 6.94916 12.9833 8.11996 14.155L14.6903 20.7304C15.0808 21.121 15.714 21.121 16.1045 20.7304C16.495 20.3399 16.495 19.7067 16.1045 19.3162L9.53246 12.7442C9.14194 12.3536 9.14194 11.7205 9.53246 11.33L16.1795 4.68297C16.57 4.29244 16.57 3.65928 16.1795 3.26875Z" fill="#964b00" />
                                            </svg>
                                        </button>
                                        <div className="mx-2 overflow-x-scroll d-flex" id="filterScroll">
                                            {
                                                categories && categories.length > 0 ?
                                                    categories.map((post) => (
                                                        <div>
                                                            <input type="checkbox" className="d-none" id={`cate` + post.id} name={`cate` + post.id} value={`cate` + post.id} onClick={(e) => selectCate(e)} />
                                                            {
                                                                allSelectedCate.includes(`cate` + post.id) === true ?
                                                                    <>
                                                                        <label for={`cate` + post.id} className='me-2 active' >{post.name}</label>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <label for={`cate` + post.id} className='me-2 checkbox-btn'>{post.name}</label>
                                                                    </>
                                                            }
                                                        </div>
                                                    ))
                                                    : ''
                                            }
                                        </div>
                                        <button onClick={scrollRight} className="bg-transparent next-btn ps-2 pe-4">
                                            <svg width="20px" height="20px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.82054 20.7313C8.21107 21.1218 8.84423 21.1218 9.23476 20.7313L15.8792 14.0868C17.0505 12.9155 17.0508 11.0167 15.88 9.84497L9.3097 3.26958C8.91918 2.87905 8.28601 2.87905 7.89549 3.26958C7.50497 3.6601 7.50497 4.29327 7.89549 4.68379L14.4675 11.2558C14.8581 11.6464 14.8581 12.2795 14.4675 12.67L7.82054 19.317C7.43002 19.7076 7.43002 20.3407 7.82054 20.7313Z" fill="#964b00" />
                                            </svg>
                                        </button>
                                        <div className="px-3 ms-2 auther-filter d-block">
                                            <select
                                                name="author"
                                                id="author"
                                                className="bg-transparent border-0"
                                                value={selectAuthors}
                                                onChange={(e) => {
                                                    setSelectAuthors(e.target.value);
                                                    filterCate(e.target.value, "author"); // Ensure API call happens
                                                }}
                                                >
                                                <option value="">Select Author</option>
                                                {authorList.map((element) => (
                                                    <option key={element.id} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="mt-4 select-auther-filter d-none">
                                        <div className="px-3 ms-2 auther-filter d-inline">
                                            <select
                                                name="author"
                                                id="author"
                                                className="bg-transparent border-0 d-inline"
                                                value={selectAuthors}
                                                onChange={(e) => {
                                                    setSelectAuthors(e.target.value);
                                                    filterCate(e.target.value, "author"); // Ensure API call happens
                                                }}
                                                >
                                                <option value="">Select Author</option>
                                                {authorList.map((element) => (
                                                    <option key={element.id} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Container>
                    </section>*/}
          {contentloading ? (
            <div
              style={{
                // textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100vw",
              }}
            >
              <p>
                <PulseLoader color="#00504E" size={20} />
              </p>
            </div>
          ) : (
            <>
              <div>
                {featuredBlogs ? (
                  featuredBlogs.length > 0 ? (
                    <section className="blog_individual">
                      <Container>
                        <OwlCarousel className="owl-theme" {...options}>
                          {
                            featuredBlogs.slice(0, 3).map((blog, index) => {
                              // if (counter < 3 && blog.is_featured == 'Yes') {
                              console.log("ddddd", counter, blog.is_featured);

                              counter = index + 1;
                              blog.content = blog.content.replace(
                                /<[^>]+>/g,
                                ""
                              );
                              blog.content = blog.content.replace(
                                /&nbsp;/g,
                                " "
                              );
                              return (
                                <>
                                  <Row className="align-items-center">
                                    <Col lg="5">
                                      <div className="item">
                                        <NavLink
                                          className="text_brand_color8 fw-500 fs-14"
                                          to={`/blog-details/${blog.slug}`}
                                        >
                                          <div className="flex flex-col p-6 transition-shadow duration-300 bg-white border border-[#e7e7e7] rounded-lg shadow-md hover:shadow-lg h-80">
                                            <div className="flex items-center justify-between mb-4">
                                              <div className="flex items-center">
                                                <div className="w-10 h-10 overflow-hidden rounded-full">
                                                  {blog.profile_pic ? (
                                                    <img
                                                      className="object-cover w-full h-full"
                                                      src={`${process.env.REACT_APP_SOCKET_URL}/upload/users/profile/${blog.profile_pic}`}
                                                      alt="Author"
                                                      onError={(e) =>
                                                        defaultUserImage(e)
                                                      }
                                                    />
                                                  ) : (
                                                    <img
                                                      className="object-cover w-full h-full"
                                                      src={dummy_coach1_sqr}
                                                      alt="Author"
                                                    />
                                                  )}
                                                </div>
                                                <span className="ml-3 font-semibold text-gray-800">
                                                  {blog.name}
                                                </span>
                                              </div>
                                              <span className="text-sm text-gray-500">
                                                {new Date(
                                                  blog.created_at
                                                ).toLocaleDateString("en-IN", {
                                                  year: "numeric",
                                                  month: "short",
                                                  day: "numeric",
                                                })}
                                              </span>
                                            </div>

                                            <h3 className="mb-2 text-xl font-bold text-gray-900 line-clamp-2">
                                              {blog.title}
                                            </h3>

                                            <p className="flex-grow mb-4 text-gray-600 line-clamp-3">
                                              {removeHTMLTags(
                                                blog.content
                                              ).substring(0, 200)}
                                            </p>

                                            <NavLink
                                              to={`/blog-details/${blog.slug}`}
                                              className="inline-flex items-center font-medium text-indigo-600 transition-colors duration-200 hover:text-indigo-800"
                                            >
                                              Read More
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-4 h-4 ml-1"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth={2}
                                                  d="M9 5l7 7-7 7"
                                                />
                                              </svg>
                                            </NavLink>
                                          </div>
                                        </NavLink>
                                      </div>
                                    </Col>
                                    <Col lg="7" className="m-0">
                                      {/* <img className="w-100" src={mental_coach} alt="" /> */}
                                      <div
                                        className="overflow-hidden"
                                        style={{
                                          height: "320px",
                                          borderRadius: "12px",
                                        }}
                                      >
                                        {blog.image ? (
                                          <img
                                            style={{ borderRadius: "12px" }}
                                            alt=""
                                            className="w-100 object-fit-cover"
                                            src={`${process.env.REACT_APP_SOCKET_URL}/upload/cab/resized/${blog.image}`}
                                            onError={(e) => defaultImage(e)}
                                            height="400px"
                                          />
                                        ) : (
                                          <img
                                            style={{ borderRadius: "12px" }}
                                            alt=""
                                            className="w-100 object-fit-cover"
                                            src={blog_card_img1}
                                            onError={(e) => defaultImage(e)}
                                            height="400px"
                                          />
                                        )}
                                      </div>
                                    </Col>
                                  </Row>
                                </>
                              );
                              // }
                            })
                            // : ''
                          }
                        </OwlCarousel>
                      </Container>
                    </section>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {latestBlogs ? (
                  latestBlogs.length > 0 ? (
                    <section>
                      <Container className="mt-4">
                        <hr />
                        <Row className="pb-4 mt-4 blogs_hdng align-items-center">
                          <Col>
                            <h4>Latest</h4>
                          </Col>
                          <Col className="col-auto">
                            <NavLink to={"/latest-blogs"}>
                              <Button
                                text="View More"
                                variant="success"
                                size="sm"
                              />
                            </NavLink>
                          </Col>
                        </Row>
                      </Container>
                      <Container>
                        <Row>
                          {latestBlogs.slice(0, 3).map((blog, index) => {
                            var l_count = index + 1;
                            if (l_count < 7) {
                              blog.content = blog.content.replace(
                                /<[^>]+>/g,
                                ""
                              );
                              blog.content = blog.content.replace(
                                /&nbsp;/g,
                                " "
                              );

                              return (
                                // <Col lg="4" sm="6">
                                //     <div className="latest_blog_card">
                                //         <div className="latest_blog_card_header">
                                //             <Row className="align-items-center">
                                //                 <Col>
                                //                     <div className="d-flex align-items-center">
                                //                         <div className="">
                                //                             {blog.profile_pic ? (
                                //                                 <img src={`${process.env.REACT_APP_SOCKET_URL}/upload/users/profile/${blog.profile_pic}`} alt="" />
                                //                             ) : (
                                //                                 <img src={live_session_img1} alt="" />
                                //                             )}
                                //                         </div>
                                //                         <span className="ms-2 fs-10 fw-600">Qoach</span>
                                //                     </div>
                                //                 </Col>
                                //                 <Col className="col-auto">
                                //                     <span className="fs-14 fw-400">{new Date(blog.created_at).toLocaleDateString('en-IN', {
                                //                         year: 'numeric',
                                //                         month: 'short',
                                //                         day: 'numeric'
                                //                     })}
                                //                     </span>
                                //                 </Col>
                                //             </Row>

                                //         </div>
                                //         <img className="latest_blog_img" src={`${process.env.REACT_APP_SOCKET_URL}/upload/cab/${blog.image}`} alt=""  onError={(e) => defaultImage(e) } />

                                //         <div className="latest_blog_card_body">
                                //             <h5 className="fs-14 fw-600">{blog.title}</h5>
                                //             <p>{(blog.content).substring(0, 150)}</p>
                                //             <NavLink to={`/blog-details/${blog.slug}`}>Read More</NavLink>

                                //         </div>
                                //     </div>
                                // </Col>
                                <Col sm="6" lg="4" className="mb-4">
                                  <BlogCard
                                    key={blog.id}
                                    blog={blog}
                                    defaultUserImage={(e) => {
                                      e.target.src = "default-user.jpg";
                                    }}
                                    defaultImage={(e) => {
                                      e.target.src = "default-blog.jpg";
                                    }}
                                    getDate={getDate}
                                    removeHTMLTags={removeHTMLTags}
                                  />
                                </Col>
                              );
                            }
                          })}
                        </Row>
                      </Container>
                    </section>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {popularBlogs ? (
                  popularBlogs.length > 0 ? (
                    <section className="most_popular">
                      <Container>
                        <hr />
                        <Row className="my-4 blogs_hdng align-items-center">
                          <Col>
                            <h4>Most Popular</h4>
                          </Col>
                          <Col className="col-auto">
                            <NavLink to={"/popular-blogs"}>
                              <Button
                                text="View More"
                                variant="success"
                                size="sm"
                              />
                            </NavLink>
                          </Col>
                        </Row>
                      </Container>
                      <Container>
                        <Row>
                          {
                            popularBlogs.slice(0, 3).map((blog, index) => {
                              // if (count < 6 && blog.is_popular == 'Yes') {
                              count = index + 1;
                              blog.content = blog.content.replace(
                                /<[^>]+>/g,
                                ""
                              );
                              blog.content = blog.content.replace(
                                /&nbsp;/g,
                                " "
                              );
                              return (
                                // <div>
                                //     <div className="p-1 mb-3 latest_blog_card">
                                //         <Row className="align-items-center">
                                //             <Col md="6">
                                //                 <div className="pb-0 latest_blog_card_header">
                                //                     <Row className="align-items-center">
                                //                         <Col>
                                //                             <div className="d-flex align-items-center">
                                //                                 <div className="">
                                //                                     {blog.profile_pic ? (
                                //                                         <img src={`${process.env.REACT_APP_SOCKET_URL}/upload/users/profile/${blog.profile_pic}`} alt="" />
                                //                                     ) : (
                                //                                         <img src={live_session_img1} alt="" />
                                //                                     )}
                                //                                 </div>

                                //                                 {console.log(blog, 'Mohit')}
                                //                                 <span className="ms-2 fs-10 fw-600">{blog.name ? blog.name : 'Qoach'}</span>
                                //                             </div>
                                //                         </Col>
                                //                         <Col className="col-auto">
                                //                             <span className="fs-14 fw-400">{new Date(blog.created_at).toLocaleDateString('en-IN', {
                                //                                 year: 'numeric',
                                //                                 month: 'short',
                                //                                 day: 'numeric'
                                //                             })}
                                //                             </span>
                                //                         </Col>
                                //                     </Row>
                                //                 </div>
                                //                 <div className="latest_blog_card_body">
                                //                     <h5>{blog.title}</h5>
                                //                     <p>{(blog.content.replace(/<[^>]+>/g, '')).substring(0, 300)}</p>
                                //                     <NavLink to={`/blog-details/${blog.slug}`}>Read More</NavLink>

                                //                     {/* <NavLink onClick={(e) => showModal(e, blog)}>Read More</NavLink> */}
                                //                 </div>
                                //             </Col>
                                //             <Col md="6">
                                //                 {/* <img className="latest_blog_img" src={mental_coach} alt="" /> */}
                                //                 <img className="latest_blog_img" src={`${process.env.REACT_APP_SOCKET_URL}/upload/cab/${blog.image}`} alt="" />

                                //                 {/* {blog.image ? (
                                //         <img className="latest_blog_img" src={`${process.env.REACT_APP_SOCKET_URL}/upload/cab/${blog.image}`} alt="" />
                                //     ) : (
                                //         <img className="latest_blog_img" src={`${mental_coach}`} alt="" />
                                //     )} */}
                                //             </Col>
                                //         </Row>
                                //     </div>
                                //     <hr />
                                // </div>
                                <Col sm="6" lg="4" className="mb-4">
                                  <BlogCard
                                    key={blog.id}
                                    blog={blog}
                                    defaultUserImage={(e) => {
                                      e.target.src = "default-user.jpg";
                                    }}
                                    defaultImage={(e) => {
                                      e.target.src = "default-blog.jpg";
                                    }}
                                    getDate={getDate}
                                    removeHTMLTags={removeHTMLTags}
                                  />
                                </Col>
                              );
                              // }
                            })
                            // : ''
                          }
                        </Row>
                      </Container>
                    </section>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {allBlogs ? (
                  allBlogs.length > 0 ? (
                    <section className="most_popular">
                      <Container>
                        <hr />
                        <Row className="my-4 blogs_hdng align-items-center">
                          <Col>
                            <h4>All</h4>
                          </Col>
                          <Col className="col-auto">
                            <NavLink to={"/all-blogs"}>
                              <Button
                                text="View More"
                                variant="success"
                                size="sm"
                              />
                            </NavLink>
                          </Col>
                        </Row>
                      </Container>
                      <Container>
                        <Row>
                          {
                            allBlogs.slice(0, 3).map((blog, index) => {
                              count = index + 1;
                              blog.content = blog.content.replace(
                                /<[^>]+>/g,
                                ""
                              );
                              blog.content = blog.content.replace(
                                /&nbsp;/g,
                                " "
                              );
                              return (
                                <Col sm="6" lg="4" className="mb-4">
                                  <BlogCard
                                    key={blog.id}
                                    blog={blog}
                                    defaultUserImage={(e) => {
                                      e.target.src = "default-user.jpg";
                                    }}
                                    defaultImage={(e) => {
                                      e.target.src = "default-blog.jpg";
                                    }}
                                    getDate={getDate}
                                    removeHTMLTags={removeHTMLTags}
                                  />
                                </Col>
                              );
                            })
                            // : ''
                          }
                        </Row>
                      </Container>
                    </section>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {featuredBlogs && featuredBlogs.length === 0 ? (
                  latestBlogs && latestBlogs.length === 0 ? (
                    popularBlogs && popularBlogs.length === 0 ? (
                      allBlogs && allBlogs.length === 0 ? (
                        <Container>
                          <div className="py-5 my-5">
                            <p className="text-center">Blog not found</p>
                          </div>
                        </Container>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>{" "}
            </>
          )}
        </>
      )}
    </>
  );
}

export default BlogComponent;
